import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55a9d1bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "ads-items favorite"
}
const _hoisted_2 = {
  key: 1,
  class: "items-in-column align-center"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Добавьте объявление в избранное", -1))
const _hoisted_4 = {
  key: 2,
  class: "ads-items favorite"
}
const _hoisted_5 = { class: "ads-items__container favorite" }
const _hoisted_6 = { class: "mb--10" }
const _hoisted_7 = { class: "medium m-font-size" }
const _hoisted_8 = { class: "ads-items__container-info favorite" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Этаж:", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Дом:", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Адрес:", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Участок: ", -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "Цена: ", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "dark-text-color" }, "id: ", -1))
const _hoisted_15 = { class: "items-in-column gap--7" }

import { computed, onMounted, ref, Ref } from 'vue';
import { useUserStore } from '@/store/modules/user';
import { ResultCardType } from '@/types';
import { PhoneButton, ShareBtn } from '@/components';
import { useAppStore } from '@/store/modules/app';


export default /*#__PURE__*/_defineComponent({
  __name: 'FavoriteAds',
  setup(__props) {

const favoriteAds: Ref<ResultCardType[] | undefined> = ref(undefined);

const isLoading = ref(false);

const deleteFavorite = async (id: number) => {
  await useUserStore().changeIsFavorite(id);
  const favoriteIndex = favoriteAds.value?.findIndex(el => el.landId === id);

  if (favoriteIndex !== undefined && favoriteIndex >= 0) {
    favoriteAds.value?.splice(favoriteIndex, 1);
  }
};
const favoriteAdsCount = computed(() => {
  return useUserStore().user?.favorite_ids.length;
});

onMounted(async () => {
  try {
    isLoading.value = true;
    favoriteAds.value = await useUserStore().getFavoriteHouses();
  } finally {
    isLoading.value = false;
  }
});

return (_ctx: any,_cache: any) => {
  const _component_base_skeleton_loader = _resolveComponent("base-skeleton-loader")!
  const _component_base_button = _resolveComponent("base-button")!
  const _component_base_image = _resolveComponent("base-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_base_icon = _resolveComponent("base-icon")!
  const _component_base_card = _resolveComponent("base-card")!

  return (isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favoriteAdsCount.value, (i) => {
          return (_openBlock(), _createBlock(_component_base_skeleton_loader, {
            key: i,
            styles: { height: '132px', width: '100%' },
            class: "mb--5",
            type: "mediumText"
          }))
        }), 128))
      ]))
    : (!favoriteAds.value || favoriteAds.value.length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _hoisted_3,
          _createVNode(_component_base_button, {
            href: { name: 'main' },
            height: "40",
            text: "К объявлениям"
          })
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(favoriteAds.value, (favoriteAd) => {
            return (_openBlock(), _createBlock(_component_base_card, {
              key: favoriteAd,
              class: "ads-items__section",
              "full-width-mobile": ""
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(_component_router_link, {
                    to: { name: 'offerCard', params: { url: favoriteAd.landUrl } }
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_base_image, {
                        src: favoriteAd.img ? favoriteAd.img[0] : undefined,
                        "border-radius": "",
                        cover: "",
                        height: "98",
                        name: "img",
                        version: "v4",
                        width: "96"
                      }, null, 8, ["src"])
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(favoriteAd.abbreviation), 1)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _hoisted_9,
                          _createTextVNode(" " + _toDisplayString(favoriteAd.floor), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_10,
                          _createTextVNode(" " + _toDisplayString(`${favoriteAd.houseArea || '-'} м²`), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _hoisted_11,
                          _createTextVNode(" " + _toDisplayString(favoriteAd.address), 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_12,
                          _createTextVNode(_toDisplayString(`${favoriteAd.landArea || '-'} сот.`), 1)
                        ])
                      ]),
                      _createElementVNode("div", null, [
                        _createElementVNode("div", null, [
                          _hoisted_13,
                          _createTextVNode(_toDisplayString(favoriteAd.price?.toLocaleString()) + " ₽ ", 1)
                        ]),
                        _createElementVNode("div", null, [
                          _hoisted_14,
                          _createTextVNode(_toDisplayString(favoriteAd.id), 1)
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_base_button, {
                      icon: "",
                      "style-type": "border",
                      withoutActive: "",
                      onClick: ($event: any) => (deleteFavorite(favoriteAd.landId))
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_base_icon, {
                          color: "#EA1F1F",
                          "font-size": "20",
                          name: "favorite",
                          width: "22"
                        })
                      ]),
                      _: 2
                    }, 1032, ["onClick"]),
                    _createVNode(_unref(ShareBtn), {
                      link: `${_unref(useAppStore)().baseUrl}/offerCard/${favoriteAd.landUrl}`,
                      color: "#009D3E",
                      "font-size": "20",
                      height: "28",
                      width: "28"
                    }, null, 8, ["link"]),
                    _createVNode(_unref(PhoneButton), {
                      phone: favoriteAd.phone,
                      "btn-type": "border",
                      "is-icon": "",
                      phoneModal: ""
                    }, null, 8, ["phone"])
                  ])
                ])
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]))
}
}

})